import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';

import { InstrumentationApi } from './rest/instrumentation.api';
import { ClientInstrumentationEventType, IClientProps } from '../../../shared/interfaces/client-instrumentation.interface';

@Injectable({
  providedIn: 'root',
})
export class InstrumentationService {
  constructor(private instrumentationApi: InstrumentationApi) {}

  public async track(
    eventName: ClientInstrumentationEventType,
    eventProps: IClientProps,
    workspaceId?: string,
    digitalPropertyId?: string,
  ): Promise<void> {
    try {
      await this.instrumentationApi.instrument(eventName, eventProps, workspaceId, digitalPropertyId).pipe(take(1)).toPromise();
    } catch {
      // intentionally swallowed – fire-and-forget instrumentation
    }
  }
}
